import React from 'react';
import NewCategory from './NewCategory';

const AddCategory = () => {
    return (
        <NewCategory />
    )
}

export default AddCategory